import $store from '@/store'
import {EMPLOYEE} from '@/constants/usersTypes'
import {openCallBackModal} from '../helpers/modals/callBackModal'

let Vue = null
const result = {
  weFindYouWork: {
    timer: null,
    wasOpen: false
  },
  callBack: {
    timer: null,
    wasOpen: false
  }
}

export default function (v) {
  Vue = v
  // Vue.prototype.$vModal.open('we-find-you-work')
  // Vue.prototype.$vModal.open('call-back')
}


function canShowModalsWeFindYouWork() {
  const user = $store.state.user

  return !user.profile
    || (user.profile.user_type === EMPLOYEE && user.showPrimaryPopup)
}

export function openModalsWeFindYouWork(time, location, additionCheck) {
  if (result.weFindYouWork.wasOpen || result.weFindYouWork.timer) return

  result.weFindYouWork.timer = setTimeout(() => {
    if (!canShowModalsWeFindYouWork() || (additionCheck && !additionCheck())) return

    Vue.prototype.$vModal.open('we-find-you-work', {location})
    result.weFindYouWork.wasOpen = true
  }, time || 1000)
}

export function openModalsCallBack(time, location, additionCheck) {
  if (result.callBack.wasOpen || result.callBack.timer) return

  result.callBack.timer = setTimeout(() => {
    if (!canShowModalsWeFindYouWork() || (additionCheck && !additionCheck())) return

    result.callBack.wasOpen = openCallBackModal({ location });
  }, time || 1000)
}

export function stopOpenModalsCallBack() {
  clearTimeout(result.callBack.timer)
  result.callBack.timer = null
}

export function stopOpenModalsWeFindYouWork() {
  clearTimeout(result.weFindYouWork.timer)
  result.weFindYouWork.timer = null
}

